import { ROUTES } from '@/constants';
import { findDonationRoute } from '@/utils/findDonationRoute';
import { findRoute } from '@/utils/findRoute';

/**
 * KB 히스토리 스택에 push하지 않을 라우트 목록.
 *
 * 이 리스트에 라우트를 추가하기 전에 다음을 확인:
 * 1. 사용자가 이 페이지에 도달한 뒤 뒤로가기를 했을 때 KB 메인 앱으로 튕기는 게 정상인지
 * 2. 메뉴/아이콘에서 이 라우트로 이동하는 진입점이 없는지 (있다면 진입점도 함께 변경)
 *
 * @see KbHistoryStack — 이 리스트를 참조해 KB 네이티브 히스토리 push 여부를 결정
 */
export const KB_HISTORY_EXCEPT_ROUTES = [
  // 가구원 정보 수정 — 모달성 단계로 자체 close 흐름이 있음
  ROUTES.MY_FAMILY_UPDATE,
  // 소셜 로그인 콜백 — 토큰 교환만 처리하고 즉시 리다이렉트
  ROUTES.AUTH,
  // 크로스 도메인 인증/콜백 — 도메인 간 토큰 전달용 transient 페이지
  ROUTES.CROSS_DOMAIN_AUTH,
  ROUTES.CROSS_DOMAIN_CALLBACK,
  // 에러 페이지 — 히스토리에 남기지 않음
  ROUTES.ERROR,
  // 혜택 알리미 — 외부 시스템 위임
  ROUTES.BENEFIT_NOTIFICATION,
  // KB Pay 필터 — KB Pay 자체 필터 모달
  ROUTES.KB_PAY_FILTER,
  // KB 가입 플로우 — 단계 이동을 자체 제어
  ROUTES.JOIN_COMMON,
  ROUTES.JOIN_COMPLETE,
  ROUTES.JOIN_USER_INFO,
] as const;

const KB_HISTORY_EXCEPT_ROUTE_IDS = new Set(
  KB_HISTORY_EXCEPT_ROUTES.map(({ id }) => id),
);

/**
 * 주어진 pathname이 KB 히스토리 push 대상에서 제외되는 라우트인지 판단.
 *
 * - 라우트 매칭이 안 되는 pathname도 push 대상에서 제외 (기존 동작 유지).
 *   findRoute가 못 찾는 신규 페이지는 KB 히스토리에 안 쌓이므로,
 *   새 페이지 추가 시 routes.ts에 등록하는 것이 중요.
 */
export const isKbHistoryExceptRoute = (pathname: string | null): boolean => {
  if (!pathname) return true;

  const currentRoute = findRoute(pathname) ?? findDonationRoute(pathname);
  if (!currentRoute) return true;

  return KB_HISTORY_EXCEPT_ROUTE_IDS.has(currentRoute.id);
};
